import { BaseEntityType, ContainerEntityType, ContainerEntitySchema } from './entitySchemas'

export const isContainerEntity = (entity: BaseEntityType): entity is ContainerEntityType => {
  return ContainerEntitySchema.safeParse(entity).success
}
